export default {
  lang: 'en',
  meta: {
    title: 'release tool',
    description: 'release tool description',
    keywords: "release tool, release, tool",
  }
}
